import React from 'react';

/**
 * Renderiza el bloque FeederSummary de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function FeederSummary({
  v
}) {
  return React.createElement("section", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03),0 0.925926vh 2.777778vh rgba(0,0,0,0.25)",
      "padding": "1.481481vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "1.111111vh",
      "minHeight": "0",
      "minWidth": "0"
    }
  }, v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "1.111111vh",
      "flexWrap": "wrap"
    }
  }, React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.388889vh",
      "fontWeight": "600",
      "whiteSpace": "nowrap"
    }
  }, v.text("Métricas de alimentación")), React.createElement("button", {
    "onClick": v.fsRecalc,
    "title": v.fsRecalcActive ? "Recálculo temporal activo" : "Recalcular puntuaciones",
    style: {
      "order": "2",
      "display": "inline-flex",
      "alignItems": "center",
      "gap": "0.462963vh",
      "background": v.fsRecalcActive ? "rgba(232,78,14,0.14)" : "transparent",
      "border": "0.092593vh solid #e84e0e",
      "color": "#ff6b2c",
      "borderRadius": "0.37037vh",
      "height": "2.777778vh",
      "padding": "0 0.625vw",
      "cursor": "pointer",
      "fontSize": "1.018519vh",
      "fontWeight": "600",
      "lineHeight": "1",
      "letterSpacing": "0.02em",
      "whiteSpace": "nowrap"
    },
    className: "scapp-full-hover"
  }, React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "1.296296vh",
    height: "1.296296vh",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round"
  }, React.createElement("path", {
    d: "M4 6h16M4 12h16M4 18h16"
  }, null), React.createElement("path", {
    d: "M8 4v4M16 10v4M10 16v4"
  }, null)), v.text("RECALCULAR")), React.createElement("div", {
    style: {
      "marginLeft": "auto",
      "order": "1",
      "display": "flex",
      "gap": "0.925926vh"
    }
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh",
      "flex": "none"
    }
  }, (v.fsMets || []).map((m, index143) => React.createElement(React.Fragment, {
    key: index143
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.37037vh 0.925926vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color,
      "fontWeight": m.fw,
      "whiteSpace": "nowrap"
    }
  }, v.text(m.label))))))), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "repeat(4,minmax(0,1fr))",
      "gap": "0.740741vh"
    }
  }, (v.fsKpis || []).map((k, index145) => React.createElement(React.Fragment, {
    key: index145
  }, React.createElement("div", {
    "onClick": k.onClick,
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh",
      "padding": "0.740741vh 1.111111vh",
      "border": "0.092593vh solid " + k.bd,
      "background": k.bg,
      "borderRadius": "0.740741vh",
      "cursor": k.cur,
      "minWidth": "0"
    }
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.092593vh",
      "minWidth": "0"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "whiteSpace": "nowrap"
    }
  }, v.text(k.l)), React.createElement("span", {
    style: {
      "font": "600 1.851852vh 'IBM Plex Mono',monospace",
      "color": k.vc,
      "whiteSpace": "nowrap"
    }
  }, v.text(k.v))), React.createElement("div", {
    style: {
      "display": "flex",
      "flexWrap": "wrap",
      "gap": "0 0.925926vh",
      "fontSize": "1.018519vh",
      "color": "#8793a6"
    }
  }, React.createElement("span", {
    style: {
      "whiteSpace": "nowrap"
    }
  }, v.text(k.s1)), React.createElement("span", {
    style: {
      "whiteSpace": "nowrap"
    }
  }, v.text(k.s2))))))), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": v.fsCols,
      "gap": "0.185185vh",
      "alignItems": "end"
    }
  }, React.createElement("span", {}, null), (v.fsHead || []).map((h, index146) => React.createElement(React.Fragment, {
    key: index146
  }, React.createElement("span", {
    style: {
      "font": "0.925926vh 'IBM Plex Mono',monospace",
      "color": h.c,
      "whiteSpace": "nowrap",
      "overflow": "visible",
      "textAlign": "left"
    }
  }, v.text(h.lab))))), v.text("\n      "), React.createElement("div", {
    "onMouseLeave": v.fsLeave,
    style: {
      "flex": "1",
      "minHeight": "0",
      "position": "relative",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh"
    }
  }, v.text("\n        "), (v.fsRows || []).map((row, index147) => React.createElement(React.Fragment, {
    key: index147
  }, React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "grid",
      "gridTemplateColumns": v.fsCols,
      "gap": "0.185185vh",
      "background": row.rowBg,
      "borderRadius": "0.277778vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": row.nC,
      "fontWeight": row.fw,
      "alignSelf": "center",
      "whiteSpace": "nowrap",
      "paddingLeft": "0.208333vw"
    }
  }, v.text(row.name)), (row.cells || []).map((c, index148) => React.createElement(React.Fragment, {
    key: index148
  }, React.createElement("div", {
    "onMouseEnter": c.enter,
    "onClick": c.click,
    style: {
      "background": c.bg,
      "outline": c.ol,
      "border": c.bd,
      "boxSizing": "border-box",
      "borderRadius": "0.185185vh",
      "cursor": "pointer",
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center",
      "font": "600 0.925926vh 'IBM Plex Mono',monospace",
      "color": c.tc,
      "minWidth": "0",
      "overflow": "hidden"
    }
  }, v.text(c.t))))))), v.text("\n        "), v.fsTip.on ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": v.fsTip.left,
      "top": v.fsTip.top,
      "transform": v.fsTip.tx,
      "zIndex": "40",
      "width": "12.5vw",
      "background": "rgba(6,14,28,0.96)",
      "border": "0.092593vh solid rgba(46,179,238,0.35)",
      "borderRadius": "0.740741vh",
      "padding": "0.925926vh 1.111111vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.462963vh",
      "pointerEvents": "none",
      "boxShadow": "0 0.740741vh 2.222222vh rgba(0,0,0,0.45)"
    }
  }, React.createElement("div", {
    style: {
      "fontWeight": "600",
      "fontSize": "1.203704vh",
      "color": "#e4e9f0",
      "paddingBottom": "0.37037vh",
      "borderBottom": "0.092593vh solid rgba(46,179,238,0.14)"
    }
  }, v.text(v.fsTip.title)), (v.fsTip.rows || []).map((r, index149) => React.createElement(React.Fragment, {
    key: index149
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "0.925926vh",
      "fontSize": "1.111111vh"
    }
  }, React.createElement("span", {
    style: {
      "color": r.c,
      "whiteSpace": "nowrap"
    }
  }, v.text(r.l)), React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": r.vc,
      "whiteSpace": "nowrap"
    }
  }, v.text(r.v))))), React.createElement("div", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#5a667a"
    }
  }, v.text("Clic para ver el desglose")))) : null, v.text("\n      ")), v.text("\n    "));
}
